import { useCallback, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from 'react-redux';
import { getPartnerId } from "utils/getPartnerData";
import { Modal, Notification, Loader, AuthLayout } from "components";
import { ROLES_PAGES } from "configs/constants";
import { loginStepTwo } from "redux_toolkit/reducers/app/appSlice";


export const LayoutUsers = ()=> {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { userData, loading } = useSelector(({ userPartner }) => userPartner);
  
  const partnerIdParam = getPartnerId() || '';
  const [_, partnerKey, activePage] = location.pathname.split("/");

  const initAppCallback = useCallback(() => {
    if(partnerIdParam) dispatch(loginStepTwo(partnerIdParam));
  }, [dispatch, partnerIdParam]);

  useEffect(()=> {
    initAppCallback();
  }, [initAppCallback]);

  useEffect(()=> {
    if(userData?.role && !ROLES_PAGES[userData.role].includes(activePage)) window.location.replace(`/${partnerKey}/home`)
  }, [userData, activePage, partnerKey]);

  useEffect(()=> {
    if(localStorage.getItem('superadmin_token')){
      navigate(`/superadmin/home`);
      return;
    } 
    if( !!!localStorage.getItem(`${partnerKey}`)) {
      navigate(`/partners`);
    }
  }, [partnerKey, navigate]);

  if (loading) return <Loader />;

  return (
    <>
      <Modal />
      <Notification/>
      { userData && <AuthLayout isSidebarOpened={+localStorage.getItem('sidebar_open')}>
        <Outlet />
      </AuthLayout>
      }
    </>
  )
}